import React, { useState, useEffect } from "react";
import axios from "axios";
import { SEOHead } from "../components/SEOHead";
import { Sidebar } from "../components/Layout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SMSPolicyPage({ navPages }) {
  const [policy, setPolicy] = useState(null);
  useEffect(() => { axios.get(`${API}/sms-privacy`).then(r => setPolicy(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="sms-policy-page">
      <SEOHead title="SMS & Text Messaging Policy" description="SMS and text messaging privacy policy and terms for Lazy Days Home Services. Learn about message frequency, opt-out (reply STOP), data rates and your consent." keywords="sms policy, text messaging terms, lazy days home services sms" />
      <div className="page-header"><h1>SMS/Text Messaging Policy</h1></div>
      <div className="main-layout"><div className="main-content"><div className="content-panel">
        {policy ? (<><h2>{policy.title}</h2><p><strong>Company:</strong> {policy.company}</p>{Object.entries(policy.content).map(([key, val]) => (<div key={key} style={{ marginBottom: 16 }}><h3 style={{ textTransform: "capitalize", marginBottom: 4 }}>{key.replace(/_/g, " ")}</h3><p>{val}</p></div>))}</>) : <div className="loading-spinner"></div>}
      </div></div><Sidebar navPages={navPages} /></div>
    </div>
  );
}
